import { renderCaptionMath, tryRenderMathToString } from "@ever-tutor/et-ui";

const MAX_CACHED = 500;

const cache = new Map<string, string | null>();

// Null means KaTeX could not parse it, so callers show the source instead.
// The check lives here because it costs a full parse: doing it at the call
// site re-parsed every maths run on every typewriter tick.
export const renderCachedCaptionMath = (latex: string): string | null => {
  const hit = cache.get(latex);
  if (hit !== undefined) return hit;

  const html = tryRenderMathToString(latex).ok
    ? renderCaptionMath(latex)
    : null;
  // Dropped wholesale rather than evicting the oldest: a bound you can reason
  // about beats an LRU nobody reads, and 500 rendered runs is far more than one
  // response needs.
  if (cache.size >= MAX_CACHED) cache.clear();
  cache.set(latex, html);
  return html;
};
